<header>
    <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a> -->
            <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container h-100">
        <div class="align-items-center">
            <div>
                <div class="global-container">
                    <div class="card login-form">
                        <div class="card-body">
                            <div class="card-text">
                                <h4 class="headerStyles">Login</h4>
                                <div class="row">
                                    <div class="col-md-12">
                                        <form [formGroup]="loginFrom" (keyup.enter)="onEnter($event)">
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <input type="text" tabindex="0" class="form-control" maxlength="100" formControlName="emailId" autocomplete="off" placeholder="Email Id" [ngClass]="{ 'is-invalid':  submitted && f.emailId.errors }">

                                                    <div *ngIf=" submitted && f.emailId.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.emailId.errors.required">EmailId {{errorMsgs.required}}</div>
                                                        <div *ngIf=" submitted && f.emailId.errors.email">{{errorMsgs.email}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 m-0">
                                                    <input  tabindex="0" style="position:relative;"  [type]="showpassword ? 'text' : 'password'" class="form-control" placeholder="Password" formControlName="passsword" autocomplete="off"  [ngClass]="{ 'is-invalid':  submitted && f.passsword.errors }">
                                                    <span (click)="eyeToggel()"style="position:absolute; right:8px;top:8px;"> <i class="icon"
                                                        [ngClass]="eyeShow ? 'fa fa-eye ' : 'fa fa-eye-slash '"
                                                        aria-hidden="true"></i></span> 
                                                        <!-- <span style="position:absolute; right:8px;top:8px;" class="fa fa-user "></span> -->
                                                    <div *ngIf=" submitted && f.passsword.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.passsword.errors.required">Password {{errorMsgs.required}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label oncopy="return false" oncut="return false" onpaste="return false" onselectstart="return false" class="capchImage">{{captchImage}}
                                                        <span (click)="generateCaptcha()" style="padding: 0 15px;"><i class="fas fa-sync-alt"></i></span>
                                                    </label>
                                                    <input type="text" class="form-control" placeholder="Enter Captcha" formControlName="captch" [ngClass]="{ 'is-invalid':  submitted && f.captch.errors }">
                                                    <div *ngIf=" submitted && f.captch.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.captch.errors.required">Captcha {{errorMsgs.required}}</div>
                                                    </div>
                                                </div>
                                            </div> -->

                                            <!-- <div class="form-group">
                                                <ngx-recaptcha2 #captchaElem
    [siteKey]="siteKey"
    formControlName="recaptcha">
  </ngx-recaptcha2>
                                              </div> -->



                                                <div class="row">
                                                    <!-- <div class="col-md-6">
                                                        <img src="{{filePath}}{{captchImage}}" alt="Captcha" />
                                                    </div> -->
                                                    <!-- <div class="form-group col-md-12"> 
                                                        <label oncopy="return false" oncut="return false" onpaste="return false" onselectstart="return false" class="form-control capchImage">{{captchaImage}}
                                                            <span (click)="getCaptchaValue()" style="padding: 0 15px;"><i class="fas fa-sync-alt"></i></span>
                                                        </label>
                                                    </div> -->

                                                    <div class="wrapper">
                                                 
                                                        <div class="captcha-area">
                                                          <div class="captcha-img">
                                                            <img src='/assets/captcha-bg.png' alt="Captch Background"/>
                                                            <span class="captcha">{{captchaImage}}</span>
                                                          </div>
                                                          &nbsp; <button tabindex="-1" class="reload-btn"><i class="fas fa-redo-alt" (click)="getCaptchaValue()"></i></button>
                                                        </div>
                                                        </div>
                                                </div>

                                                <div class="row">
                                                    <div class="form-group col-md-12">
                                                        <input  tabindex="0" type="text" class="form-control" placeholder="Enter Captcha" formControlName="captcha" autocomplete="off" 
                                                        [ngClass]="{ 'is-invalid':  submitted && f.captcha.errors }" maxlength="5">
                                                        <div *ngIf=" submitted && f.captcha.errors" class="invalid-feedback">
                                                            <div *ngIf=" submitted && f.captcha.errors.required">Captcha {{errorMsgs.required}}</div>
                                                        </div>
                                                    </div>
                                                </div>



                                                
                                                   

                                            <div class="row">
                                                <div style="padding-bottom: 5px;" class="col-md-12">
                                                </div>
                                                <div class="col-md-12">
                                                    <button class="form-control btn btn-primary" type="submit" [disabled]="!loginFrom.valid" (click)="getRandomKeyGenerator()">Login</button>
                                                </div>
                                                <!-- <div class="col-md-12" style="padding-top: 5px;">
                                                    <p>Don't have an account? <a routerLink="../register">Register</a> </p>
                                                </div> --><br><br><br>
                                                <div class="col-md-12" style="padding-top: 5px;text-align: center;font-size: 15px;">
                                                    <p>
                                                        <a routerLink="../forgotpwd" tabindex="0" *ngIf="!moduleStdReg">Forgot Password</a> 
                                                        <a routerLink="../../forgotpwd/student" tabindex="0" *ngIf="moduleStdReg">Forgot Password</a> 
                                                        <br>
                                                        <a routerLink="../../forgotusr/student" tabindex="0" *ngIf="moduleStdReg">Forgot User Id</a> 
                                                        <br>
                                                        <a routerLink="../../allregister/register/student" tabindex="0" style="color: red;" *ngIf="moduleStdReg">Not Registered? click here to SignUp </a> 
                                                    </p>
                                                </div>
                                                <div class="col-md-12" *ngIf="module==='uidr'" style="padding-top: 5px;text-align: center;font-size: 15px;">
                                                    <p><a routerLink="../../uidrRegistration" tabindex="0">New Unique IDR Registration</a> </p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

